import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { SessionService } from "../../services/login.service";
import { LoginPromptService } from "../../shared/components/login-prompt-dialog/login-prompt.service";

export const authGuardDialog: CanActivateFn = (route, state) => {
  const session = inject(SessionService);
  const loginPrompt = inject(LoginPromptService);
  const router = inject(Router);

  if (session.isAuthenticated()) return true;

  loginPrompt.openLoginRequired(state.url === "/cart" ? "cart" : "generic");
  return router.createUrlTree(["/home"]);
};
